import React from "react";
import { FaStar } from "react-icons/fa";
import { RiDoubleQuotesR } from "react-icons/ri";
import testimonial1 from "../../images/testimonial-1.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const Section9 = () => {
  const slider = [
    {
      content:
        "Thank you, Pixiu Events! The event was spectacular. Both kids and adults enjoyed it immensely, and your team's attention to detail was outstanding. We can't wait to work with you again!",
      src: testimonial1,
      alt: "clinet1",
      name: "Shivani",
    },
    {
      content:
        "Thank you, Pixiu Events! The event was spectacular. Both kids and adults enjoyed it immensely, and your team's attention to detail was outstanding. We can't wait to work with you again!",
      src: testimonial1,
      alt: "clinet2",
      name: "Supriya",
    },
    {
      content:
        "Thank you, Pixiu Events! The event was spectacular. Both kids and adults enjoyed it immensely, and your team's attention to detail was outstanding. We can't wait to work with you again!",
      src: testimonial1,
      alt: "clinet3",
      name: "Akansha",
    },
    {
      content:
        "Thank you, Pixiu Events! The event was spectacular. Both kids and adults enjoyed it immensely, and your team's attention to detail was outstanding. We can't wait to work with you again!",
      src: testimonial1,
      alt: "clinet4",
      name: "Akriti",
    },
  ];
  return (
    <div>
      <section className="testimonial bg-light">
        <div className="container bg-accent">
          <h2 className="section-heading">Testimonials</h2>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]} // Add modules here
            spaceBetween={30}
            slidesPerView={1}
            navigation
            // pagination={{ clickable: true }}
            autoplay={{ delay: 4500 }}
            loop={true}
          >
            {slider.map((slide) => {
              return (
                <SwiperSlide>
                  <div className="testimonial__listItem">
                    <div className=" flow-content testimonial__listItem-content">
                      <h3>
                        <RiDoubleQuotesR className="quote-icon" />
                      </h3>
                      <p>{slide.content}</p>
                      <div className="testimonial__rating">
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                        <FaStar />
                      </div>
                      <div className="testimonial__image">
                        <img src={slide.src} alt={slide.alt} />
                      </div>
                    </div>
                    <p className="testimonial__listItem-name">{slide.name}</p>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section>
    </div>
  );
};

export default Section9;
